module.exports = __webpack_public_path__ + "img/camera.ac9f24c4.svg";